import { render, staticRenderFns } from "./add-source.vue?vue&type=template&id=30171442&scoped=true&"
import script from "./add-source.vue?vue&type=script&lang=js&"
export * from "./add-source.vue?vue&type=script&lang=js&"
import style0 from "./add-source.vue?vue&type=style&index=0&id=30171442&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30171442",
  null
  
)

export default component.exports